import { Link } from "react-router-dom";
import { LogOut, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const APPS = {
  client: { label: "Passenger app", home: "/portal/client", login: "/portal/client/login" },
  driver: { label: "Chauffeur app", home: "/portal/driver", login: "/portal/driver/login" },
  office: { label: "Dispatch app", home: "/app", login: "/app/login" },
};

const appForRole = (role) =>
  role === "driver" ? APPS.driver : role === "client" ? APPS.client : APPS.office;

/**
 * Shown when someone opens one app while signed in with an account that belongs to another.
 * Deliberately does NOT auto-redirect: an installed PWA has its own scope, so bouncing the user
 * to another app's route just makes the passenger app display the dispatch board.
 */
export const WrongDoor = ({ expected }) => {
  const { user, logout } = useAuth();
  const here = APPS[expected];
  const theirs = appForRole(user?.role);

  return (
    <div data-testid="wrong-door" className="flex min-h-screen items-center justify-center bg-ink-900 px-5 py-12">
      <div className="w-full max-w-md rounded-2xl border border-ink-600 bg-ink-800/70 p-8">
        <ShieldAlert className="h-6 w-6 text-gold" />
        <h1 className="mt-5 text-2xl font-bold tracking-tight text-slate-50">
          This is the {here.label.toLowerCase()}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          You are signed in as <span className="text-slate-200">{user?.name || user?.email}</span>, and
          that account belongs to the {theirs.label.toLowerCase()}. Sign out to use this app with a
          different account.
        </p>
        <Button data-testid="wrong-door-signout" onClick={logout}
          className="mt-7 h-11 w-full bg-gold text-ink-900 hover:bg-gold-light">
          <LogOut className="mr-2 h-4 w-4" /> Sign out and sign in here
        </Button>
        <p className="mt-5 text-center text-xs text-slate-500">
          Meant to open your own app?{" "}
          <Link to={theirs.home} data-testid="wrong-door-own-app" className="text-gold underline">
            Go to the {theirs.label.toLowerCase()}
          </Link>
        </p>
      </div>
    </div>
  );
};
